import { motion } from "framer-motion";
import { AlarmClockCheck, ShieldCheck, Folder } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const CARDS = [
    {
        icon: AlarmClockCheck,
        title: "Say goodbye to missed doses",
        body: "Smart, kind reminders keep you on schedule and bring peace of mind to your daily routine.",
    },
    {
        icon: ShieldCheck,
        title: "Ingredient & allergy checks",
        body: "Instant allergy alerts and drug-interaction warnings powered by FDA-verified data and AI.",
    },
    {
        icon: Folder,
        title: "Everything in one place",
        body: "Your full medication list, dose history and adherence — ready to share with your GP.",
    },
];

export default function Why() {
    return (
        <section className="px-6 py-14" data-testid="why-section">
            <motion.p
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: EASE }}
                className="text-teal-dark font-bold text-[13px] tracking-[0.14em] uppercase"
            >
                Why Med Check Alarm
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.08 }}
                className="mt-3 font-extrabold tracking-tight leading-[1.08] text-4xl text-ink"
            >
                Turn worry into peace of mind
            </motion.h2>
            <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.16 }}
                className="mt-4 text-black/55 text-[17px] leading-relaxed"
            >
                Med Check Alarm simplifies your medication routine so you can stay on track
                and informed — with the confidence of FDA-verified data and AI-powered checks.
            </motion.p>

            <div className="mt-9 space-y-4">
                {CARDS.map((c, i) => (
                    <motion.div
                        key={c.title}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.6, ease: EASE, delay: i * 0.08 }}
                        className="flex gap-4 rounded-3xl border border-black/8 bg-white p-5 shadow-[0_6px_24px_-12px_rgba(0,0,0,0.12)]"
                        data-testid={`why-card-${i + 1}`}
                    >
                        <span className="w-12 h-12 rounded-full bg-teal-soft text-teal-dark grid place-items-center shrink-0">
                            <c.icon size={22} />
                        </span>
                        <div>
                            <h3 className="font-bold text-lg leading-snug text-ink">{c.title}</h3>
                            <p className="mt-1.5 text-[15px] leading-relaxed text-black/55">{c.body}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
